<template lang="pug">
  .card-content
    .members-tables
      MembersTable(
        :key="enableAdd(team.numMembers + stagedMembers.length)"
        type="team"
        mode="static"
        :loading="false"
        :static-members-data="allProgramMembersNotOnATeam ? allProgramMembersNotOnATeam.data : []"
        :static-pagination-object="paginationObject ? paginationObject : null"
        :static-fetch-action="fetchUnassignedMembers"
        :enable-search="true"
        :search-fields="['username', 'email']"
        @search="onSearch"
        :enable-add="enableAdd(team.numMembers + stagedMembers.length)"
        :title="membersTableTitle"
        :empty-message="allProgramMembers && searching && 'No members found...' || ''"
        :includeByType="includeByType"
        :notInTeam="true"
        :inOrganizationId="inOrganizationId"
      )
      .level
      MembersTable.mt-6(
        v-if="!_.isEmpty(stagedMembers)"
        mode="receiver"
        :enable-remove="true"
        :title="receiverTitle"
        :empty-message="allProgramMembers && 'Awaiting members ...' || ''"
      )
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MembersTable from "@@/Members/MembersTable";

export default {
  name: "TeamIncludeMembers",

  components: { MembersTable },

  props: {
    team: {
      type: Object,
      default: () => {}
    },

    includeByType: {
      type: String,
      default: "invite"
    },

    inOrganizationId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      allProgramMembers: [],
      loadingMembers: false,
      allProgramMembersNotOnATeam: [],
      searchString: "",
      paginationObject: null,
      searching: false
    };
  },

  computed: {
    // TODO refactor to teamBuilder
    ...mapGetters("challengeBuilder", ["stagedMembers"]),

    receiverTitle() {
      const textByType = {
        invite: "Members To Be Invited",
        add: "Members To Be Added"
      };

      return this._.get(textByType, this.includeByType, "Future Team Members");
    },

    membersTableTitle() {
      if (this.inOrganizationId) {
        return "Organization Members Not In A Team:";
      }
      return "Members Not In A Team:";
    }
  },

  async mounted() {
    this.onSearch = this._.debounce(async query => {
      query === "" ? (this.searching = false) : (this.searching = true);
      this.searchString = query;
      this.fetchUnassignedMembers();
    }, 500);
    await this.fetchUnassignedMembers();
  },

  methods: {
    ...mapActions("challengeBuilder", ["unstageMember", "stageMember"]),
    ...mapActions("program", ["fetchMembers"]),

    enableAdd(teamNumMembers) {
      return teamNumMembers < this.team.maxMembers;
    },

    onSearch() {
      // defining this here, but is overwritten in the
      // mounted call.  Using debounce requires this
      // approach in order for it to work when
      // the component instance is available.
    },

    async fetchUnassignedMembers(payload) {
      let page,
        sortColumn,
        sortOrder = null;
      if (payload) {
        page = payload.page;
        sortColumn = payload.sortColumn;
        sortOrder = payload.sortOrder;
      }

      const programId = this.$auth.user().programId;
      try {
        let params = {
          page,
          perPage: 7,
          sortColumn,
          sortOrder,
          searchString: this.searchString
        };
        const response = await this.axios.get(
          `programs/${programId}/members-not-in-team`,
          { params }
        );
        this.allProgramMembersNotOnATeam = response.data;
        this.paginationObject = response.data.pagination;
      } catch (error) {
        this.fetchUnassignedMembersError = error;
      }
    }
  }
};
</script>

<style lang="sass">
.challenge-invite-members
  .members-tables
    width: 100%
    min-height: 550px
</style>
